import { gql } from '@apollo/client';
import { Species } from '@bondvet/types/booking';
import isEmail from 'validator/lib/isEmail';
import useBookingQuery from './useBookingQuery';

export const query = gql`
    query patientsAndContactInfo($email: Email!) {
        patientsAndContactInfo(email: $email) {
            contactInfo {
                _id
                firstName
                lastName
                phoneNumberLast4
                defaultLocation
                smsMarketing
                smsTransactional
                smsConversational
            }
            patients {
                _id
                name
                species
                _vetspire {
                    id
                }
            }
        }
    }
`;

export type KnownPatient = {
    _id: string;
    name: string;
    species: Species | null;
    _vetspire: {
        id: string;
    };
};

type ContactInfo = {
    _id: string;
    firstName: string | null;
    lastName: string | null;
    phoneNumberLast4: string | null;
    defaultLocation: string | null;
    smsMarketing: boolean | null;
    smsTransactional: boolean | null;
    smsConversational: boolean | null;
};

export interface PatientsAndContactInfoQuery {
    patientsAndContactInfo: {
        contactInfo: ContactInfo;
        patients: KnownPatient[];
    };
}

export interface UsePatientsAndContactInfoProps {
    email: string;
}

type UsePatientsAndContactInfo = {
    data: PatientsAndContactInfoQuery | undefined;
    loading: boolean;
};

export default function usePatientsAndContactInfo({
    email,
}: UsePatientsAndContactInfoProps): UsePatientsAndContactInfo {
    const { data, loading } = useBookingQuery<PatientsAndContactInfoQuery>(
        query,
        {
            variables: { email },
            skip: !email || !isEmail(email),
        },
    );

    return { data, loading };
}
